import React from 'react';
import SideNavBar from '../../components/SideNavBar/SideNavBar';
import useSidebarStore from '../../store/sidebarStore';
import * as S from './MainLayout.style';

const MainLayout = ({ 
  children, 
  paddingHorizontal = 0
}) => {
  const { isExpanded } = useSidebarStore();

  return (
    <S.MainLayoutWrapper>
      {/* 사이드 내비게이션 */}
      <S.SideNavWrapper isExpanded={isExpanded}>
        <SideNavBar />
      </S.SideNavWrapper>

      {/* 메인 콘텐츠 */}
      <S.ContentArea 
        paddingHorizontal={paddingHorizontal}
        sidebarExpanded={isExpanded}
      >
        {children}
      </S.ContentArea>
    </S.MainLayoutWrapper>
  );
};

export default MainLayout;